import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { AttachedFilePermissionItemDto, AttachedFilePermissionType, UserDto, UserGroupDto } from 'models';
import Select, { PropsValue } from 'react-select';
import { Row } from 'react-bootstrap';
import { makeKey } from './utilities';
import * as z from 'zod';

export interface IPermissionItemForm {
    id: string;
    type?: string;
}

const validationSchema = z.object({
    id: z.string(),
    type: z.string().min(1),
});

export interface Option {
    value: string;
    label: string;
}
export interface GroupedOption {
    readonly label: string;
    readonly options: readonly Option[];
}

export function AddEditPermissionForm(
    props: {
        addOrUpdateItem: (form: IPermissionItemForm) => void;
        abortItemEdit: () => void;
        editedPermissionItem: AttachedFilePermissionItemDto;

        users: UserDto[];
        userGroups: UserGroupDto[];
        permissions: AttachedFilePermissionItemDto[];
    }) {
    const { editedPermissionItem, users, userGroups } = props;
    const [editedItem, setEditedItem] = useState<IPermissionItemForm>({ id: null, type: null });

    const isEdit = !!editedItem?.id;

    const {
        register, handleSubmit, reset, formState: { errors }, control, watch
    } = useForm<IPermissionItemForm>({
        resolver: zodResolver(validationSchema),
        defaultValues: editedItem,
        //values: editedItem,
        resetOptions: {
            keepDirtyValues: false,
            keepErrors: false, // input errors will be retained with value update
        }
    });

    useEffect(() => {
        if (props.editedPermissionItem) {
            const item = props.editedPermissionItem;
            let editedItem: IPermissionItemForm = { id: null, type: null };
            if (item.user || item.userGroup) {
                editedItem = { id: makeKey(item), type: item.type.toString() };
            }
            console.log("editItem() ", "item=", item, "editedItem=", editedItem);
            setEditedItem(editedItem);
            reset(editedItem);
        }
    }, [props.editedPermissionItem]);

    if (!(users && userGroups && props.permissions))
        return (<></>);

    let groupedOptions: GroupedOption[] = [];
    if (users) {
        groupedOptions.push({
            label: 'Användare', options: users
                .filter(x => -1 == props.permissions.findIndex(p => p.user?.id == x.id))
                .map(x => { return { label: x.fullName, value: "u" + x.id }; })
        });
    }
    if (userGroups) {
        groupedOptions.push({
            label: 'Grupper', options: userGroups
                .filter(x => -1 == props.permissions.findIndex(p => p.userGroup?.id == x.id))
                .map(x => { return { label: x.name, value: "g" + x.id }; })
        });
    }

    return (
        <Modal show={editedPermissionItem != null} onHide={props.abortItemEdit}>
            <Form onSubmit={handleSubmit(props.addOrUpdateItem)}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEdit ? "Redigera" : "Ny"} rättighet</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className={`mb-3 ${errors.id ? 'is-invalid' : ''}`} controlId="formId">
                        <Form.Label>Användare / Grupp</Form.Label>

                        {!isEdit &&
                            <Controller
                                control={control}
                                name="id"
                                render={({
                                    field: { onChange, onBlur, value: formFieldValue, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState,
                                }) => {
                                    function getValue(formFieldValue: string): PropsValue<Option> {
                                        let value = groupedOptions.map(x => x.options.find(y => y.value == formFieldValue)).filter(x => !!x);
                                        const retval = value.shift();
                                        // console.log("getValue", retval);
                                        return retval || null;
                                    }

                                    //console.log("error", error);
                                    return (
                                        <Select<Option, false, GroupedOption>
                                            //value={formFieldValue.startsWith("u") users?.find((u) => u.id.toString() == formFieldValue)}
                                            defaultValue={null}
                                            value={getValue(formFieldValue)}
                                            onChange={(newValue) => { console.log("onChange", newValue); onChange(newValue.value); }}
                                            options={groupedOptions}
                                            //getOptionLabel={val => val.fullName && val.fullName; `${val.fullName}`}
                                            //formatOptionLabel={(data, x) => {return <div style={{display: "flex", justifyContent: "left"}}><div style={{marginLeft: (data.level * 10) + "px"}}>Test{new Array(data.level).map(y => (<>&nbsp;</>))}</div> <div>{data.file.fileName}</div></div>}}
                                            //getOptionValue={val => val.id.toString()}
                                            className='react-select' />
                                    );
                                }} />}
                        {isEdit && <Form.Control
                            type="text"
                            placeholder={editedPermissionItem?.user?.fullName || editedPermissionItem?.userGroup?.name}
                            aria-label="Disabled input example"
                            readOnly />}

                        {errors.id && (
                            <Form.Control.Feedback type="invalid" className='d-block'>Detta fält är obligatoriskt.</Form.Control.Feedback>
                        )}

                    </Form.Group>

                    <Row>
                        <Form.Group className="mb-3 col-auto" controlId="formType">
                            <Form.Check
                                label="Läs"
                                type="radio"
                                id="typeRead"
                                value={AttachedFilePermissionType.ReadOnly}
                                inline={true}
                                {...register('type')} />
                            <Form.Check
                                label="Läs/skriv"
                                type="radio"
                                id="typeReadWrite"
                                value={AttachedFilePermissionType.ReadWrite}
                                inline={true}
                                {...register('type')} />
                            {errors.type && (
                                <Form.Control.Feedback type="invalid" className='d-block'>Detta fält är obligatoriskt.</Form.Control.Feedback>
                            )}
                        </Form.Group>
                        <div className="col-auto">
                            {/* <Button variant="primary" onClick={addItem}>
Lägg till
</Button> */}
                            {/* <Stack direction="horizontal" gap={2} className='mb-3'>
    <Button variant="primary" type="submit" size='sm'>
        {isEdit ? "Uppdatera" : "Lägg till"}
    </Button>

    <Button variant="secondary" onClick={props.abortItemEdit} size='sm'>
        Rensa
    </Button>

</Stack> */}
                        </div>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="submit">
                        Spara
                    </Button>
                    <Button variant="secondary" onClick={props.abortItemEdit}>
                        Avbryt
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>

    );
}
